<template>
    <div class="feedbackboard">
        <div class="feedback-phonetic">
            <span class="feedback__label">TRANSKRİPSİYON</span>
            <div class="feedback-phonetic-values">
                <span
                    class="feedback-phonetic__value feedback-phonetic__value--correct"
                    :class="{'feedback-phonetic__value--skipped': $store.state.feedbackData.transcriptionFull.answerValue == ''}">
                    <span class="feedback-phonetic__bracket">[</span>
                    {{ this.$store.state.feedbackData.transcriptionFull.correctValue }}
                    <span class="feedback-phonetic__bracket">]</span>
                </span>
                <span
                    v-if="showAnswerFeedback()"
                    class="feedback-phonetic__value feedback-phonetic__value--incorrect">
                    <span class="feedback-phonetic__bracket">[</span>
                    {{ this.$store.state.feedbackData.transcriptionFull.answerValue }}
                    <span class="feedback-phonetic__bracket">]</span>
                </span>
            </div>
        </div>

        <div class="feedback-transcription">
            <span class="feedback__label">YAPISAL ÇÖZÜMLEME</span>
            
            <div class="feedback-phones">
                <div
                    class="feedback-phone feedback-phone--correct"
                    v-for="(phone, index) in $store.state.feedbackData.transcriptionSegmental.correctValue"
                    :class="{'feedback-phone--skipped': $store.state.feedbackData.transcriptionFull.answerValue == ''}">
                    <span class="feedback-phone__value">
                        <span class="feedback-phone__value-phone">{{ getPhone(phone) }}</span>
                        <span
                            v-if="getDiacritic(phone)"
                            class="feedback-phone__value-diacritic"
                            :class="diacriticClass(phone)">{{ getDiacritic(phone) }}</span>
                    </span>
                    <span class="phone-number">{{ index+1 }}</span>
                </div>
            </div>

            <div
                v-if="showAnswerFeedback()"
                class="feedback-phones">
                <div
                    class="feedback-phone"
                    v-for="(phone, index) in $store.state.feedbackData.transcriptionSegmental.answerValue"
                    :class="answerPhoneClass(phone, index)">
                    <span class="feedback-phone__value">
                        <span class="feedback-phone__value-phone">{{ getPhone(phone) }}</span>
                        <span
                            v-if="getDiacritic(phone)"
                            class="feedback-phone__value-diacritic"
                            :class="diacriticClass(phone)">{{ getDiacritic(phone) }}</span>
                    </span>
                    <span class="phone-number">{{ index+1 }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        methods: {
            showAnswerFeedback(){
                if(this.$store.state.feedbackData.transcriptionFull.answerValue == ''){
                    return false;
                }
                return this.$store.state.feedbackData.transcriptionFull.answerValue != this.$store.state.feedbackData.transcriptionFull.correctValue;
            },

            getPhone(phone){
                if(!phone){
                    return '';
                }

                let results = phone.match(this.$store.state.pattern.transcriptionSegment);
                return results[1];
            },

            getDiacritic(phone){
                if(!phone){
                    return '';
                }

                let results = phone.match(this.$store.state.pattern.transcriptionSegment);
                return results[2];
            },

            diacriticClass(phone){
                if(!phone){
                    return '';
                }

                let results = phone.match(this.$store.state.pattern.transcriptionSegment);
                if(results[2] == 'ʰ'){
                    return 'feedback-phone--aspirated';
                }
                if(results[2] == '•'){
                    return 'feedback-phone--shift';
                }
                if(results[2] == ':'){
                    return 'feedback-phone--long';
                }
                return '';
            },

            answerPhoneClass(answerPhone, idx){
                return this.$store.state.feedbackData.transcriptionSegmental.correctValue[idx] == answerPhone ? 'feedback-phone--correct' : 'feedback-phone--incorrect';
            }
        }
    };
</script>
<style scoped src="@/css/components/feedbackboard-phonetic-transcription.css"></style>